import { JsonObj } from '@mhp/general-interface';

export const errorsSelector = (state: JsonObj) => state.errors.errors;
